import { render } from "./PageLoglar.vue?vue&type=template&id=6c8a8e6a"
import script from "./PageLoglar.vue?vue&type=script&lang=js"
export * from "./PageLoglar.vue?vue&type=script&lang=js"
script.render = render

export default script